'use client';

import Link from 'next/link';
import { trackEvent } from '../google-tag-manager';

const BookDemoLink: React.FC<{
  className?: string;
  children?: React.ReactNode;
}> = (props) => {
  const { className, children } = props;

  return (
    <Link
      href="/book-demo?open=true"
      as="/book-demo"
      className={className}
      onClick={() => {
        trackEvent({ event: 'book_demo_click' });
      }}
    >
      {children}
    </Link>
  );
};

export default BookDemoLink;
